<template>
  <v-container fluid class="px-0">
    <v-card elevation="2" class="mx-auto">
      <v-card-title class="white--text green darken-2 py-4 px-5 d-flex align-center">
        <v-icon left color="white">mdi-fuel</v-icon>
        {{ modoEdicao ? 'Editar Requisição' : 'Nova Requisição' }} {{ $vuetify.breakpoint.smAndDown ? '' : ' de Abastecimento'}}
        <v-spacer></v-spacer>
        <v-btn
            color="white"
            outlined
            :disabled="salvando"
            @click="$router.push({ name: 'financeiro-abastecimentos-requisicoes' })"
        >
          <v-icon>mdi-arrow-left</v-icon>
          <span class="ml-2 d-none d-sm-flex">Voltar</span>
        </v-btn>
      </v-card-title>

      <v-divider/>

      <v-card-text class="pa-6">
        <v-form ref="form" v-model="formularioValido" @submit.prevent="salvarRequisicao">
          <v-row>
            <fieldset class="mx-4 pa-2 rounded" style="height: 500px; overflow: auto" v-if="false">
              <legend> TELA DE VERIFICAÇÃO </legend>
              Colaborador Selecionado: {{dados.idfuncionario}}<br/><br/>
              Fornecedor Selecionado: {{dados.idclifor}}<br/><br/>
              Veiculo Selecionado: {{dados.idveiculo}}<br/><br/>
              Placa: {{veiculoSelecionado.placa}}<br/><br/>
              Odometro: {{dados.odometro}}<br/><br/>
              Path Odometro: {{dados.path}}<br/><br/>
              Imagem Odometro: {{imagemOdometro}}<br/><br/>
              -------------------------------------------------------------------------------------------<br/>

<!--              Fornecedores {{fornecedores}}<br/><br/>-->
<!--              Colaboradores {{colaboradores}}<br/><br/>-->
<!--              Veiculos {{veiculos}}<br/><br/>-->
            </fieldset>

            <!-- Seção: Informações da Requisição -->
            <v-col cols="12">
              <div class="section-header">
                <v-icon left color="primary">mdi-file-document</v-icon>
                <span class="text-h6 font-weight-medium">Informações da Requisição</span>
              </div>
            </v-col>

            <!-- Filial -->
            <v-col cols="12" md="6">
              <v-autocomplete
                  v-model="dados.idfilial"
                  :items="filiaisFiltro"
                  :loading="carregandoFiliais"
                  :rules="[rules.required]"
                  item-text="filial"
                  item-value="idfilial"
                  label="Filial *"
                  outlined
                  dense
                  hide-details="auto"
                  prepend-inner-icon="mdi-office-building"
                  clearable
                  :disabled="!podeAlterarFilial"
                  @change="atualizaDadosFilial()"
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Nenhuma filial encontrada</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>

            <!-- Colaboradores -->
            <v-col cols="12" md="6">
              <v-autocomplete
                  v-model="dados.idfuncionario"
                  :search-input.sync="search"
                  :items="colaboradores"
                  :loading="carregandoColaboradores"
                  :rules="[rules.required]"
                  item-text="nome"
                  item-value="idcliente"
                  label="Colaborador *"
                  outlined
                  dense
                  hide-details="auto"
                  prepend-inner-icon="mdi-account"
                  clearable
                  no-filter
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="mb-2">
                        {{ search && !idfilialColaborador ? 'Nenhum resultado encontrado' : search ?'Nenhum resultado encontrado na filial selecionada' : 'Digite para buscar colaboradores' }}
                      </v-list-item-title>

                      <div v-if="search && colaboradores.length === 0 && idfilialColaborador">
                        <v-btn
                            class="mt-2"
                            color="primary"
                            text
                            small
                            outlined
                            @click="listarTodosColaboradores(search)"
                            :loading="carregandoColaboradores"
                        >
                          <v-icon left small>mdi-magnify</v-icon>
                          Buscar em todas as filiais
                        </v-btn>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>

            <!-- Fornecedor -->
            <v-col cols="12" md="6">
              <v-autocomplete
                  v-model="dados.idclifor"
                  :search-input.sync="search2"
                  :items="fornecedores"
                  :loading="carregandoFornecedores"
                  :rules="[rules.required]"
                  item-text="nome"
                  item-value="idcliente"
                  label="Fornecedor *"
                  outlined
                  dense
                  hide-details="auto"
                  prepend-inner-icon="mdi-store"
                  clearable
                  no-filter
                  placeholder="Digite para buscar fornecedores..."
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ search2 ? 'Nenhum fornecedor encontrado' : 'Digite para buscar fornecedores' }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>

            <!-- Seção: Informações do Veículo -->
            <v-col cols="12" class="pt-6">
              <div class="section-header">
                <v-icon left color="primary">mdi-car</v-icon>
                <span class="text-h6 font-weight-medium">Informações do Veículo</span>
              </div>
            </v-col>

            <!-- Tipo de Veículo -->
            <v-col cols="12" md="6">
              <v-autocomplete
                  v-model="dados.idtipo"
                  :items="tiposVeiculo"
                  :rules="[rules.required]"
                  item-text="tipo"
                  item-value="idtipo"
                  label="Tipo de Veículo *"
                  outlined
                  dense
                  hide-details="auto"
                  prepend-inner-icon="mdi-car-multiple"
                  clearable
                  @change="alteraTipoVeiculo()"
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Nenhum tipo encontrado</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>

            <!-- Veículo -->
            <v-col cols="12" md="6">
              <v-autocomplete
                  v-model="dados.idveiculo"
                  :items="veiculos"
                  :loading="carregandoVeiculos"
                  :rules="[rules.required]"
                  item-text="veiculoplaca"
                  item-value="idveiculo"
                  label="Veículo *"
                  outlined
                  dense
                  hide-details="auto"
                  prepend-inner-icon="mdi-car"
                  clearable
                  @change="selecionarVeiculo"
              ></v-autocomplete>
            </v-col>

            <!-- Hodômetro Atual -->
            <v-col cols="12" md="6" v-if="registroObrigatorio">
              <v-text-field
                  v-model.number="dados.odometro"
                  :rules="registroObrigatorio ? [rules.required, rules.positivo, rules.inteiro] : []"
                  label="Hodômetro Atual (KM) *"
                  suffix="KM"
                  outlined
                  dense
                  hide-details="auto"
                  prepend-inner-icon="mdi-speedometer"
                  placeholder="Ex: 150000"
                  maxlength="6"
              />
            </v-col>

            <!-- Placa (somente leitura) -->
            <v-col cols="12" md="6" v-if="registroObrigatorio">
              <v-text-field
                  v-model="veiculoSelecionado.placa"
                  :rules="registroObrigatorio ? [rules.required, rules.placa] : [rules.placa]"
                  label="Placa *"
                  outlined
                  dense
                  hide-details="auto"
                  prepend-inner-icon="mdi-license"
                  readonly
                  placeholder="Selecione um veículo"
              />
            </v-col>

            <!-- Upload de Imagem -->
            <v-col cols="12" md="6" v-if="registroObrigatorio">
              <v-file-input
                  prepend-inner-icon="mdi-paperclip"
                  append-icon="mdi-camera"
                  prepend-icon=""
                  v-model="imagemOdometro"
                  :rules="registroObrigatorio ? [rules.required] : []"
                  accept="image/*"
                  label="Foto do Hodômetro *"
                  outlined
                  dense
                  hide-details="auto"
                  placeholder="Selecione uma imagem"
                  @change="processarImagem"
              />
            </v-col>

            <!-- Preview da Imagem -->
            <v-col cols="12" md="6" class="pt-0" v-if="previewImagem && registroObrigatorio">
              <div class="text-caption grey--text text--darken-1 mb-2">Preview da Imagem:</div>
              <v-img
                  :src="previewImagem"
                  max-width="200"
                  max-height="150"
                  class="preview-image"
                  @click="visualizarImagemCompleta"
              >
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
              <div class="caption grey--text mt-1">Clique para visualizar em tamanho real</div>
            </v-col>

            <!-- Seção: Tipo de Abastecimento -->
            <v-col cols="12" class="pt-6">
              <div class="section-header">
                <v-icon left color="primary">mdi-fuel</v-icon>
                <span class="text-h6 font-weight-medium">Tipo de Abastecimento</span>
              </div>
            </v-col>

            <!-- Tipo de Requisição -->
            <v-col cols="12" md="6">
              <v-select
                  v-model="dados.tipo_abastecimento"
                  :items="tiposAbastecimento"
                  :rules="[rules.required]"
                  item-text="tipoabastecimento"
                  item-value="idtipoabastecimento"
                  label="Tipo de Requisição *"
                  outlined
                  dense
                  hide-details="auto"
                  prepend-inner-icon="mdi-format-list-bulleted-type"
                  @change="limparValoresAbastecimento"
              />
            </v-col>

            <!-- Combustível -->
            <v-col cols="12" md="6">
              <v-autocomplete
                  v-model="dados.idproduto"
                  :items="produtos"
                  :rules="[rules.required]"
                  :loading="carregandoProdutos"
                  item-text="produto"
                  item-value="idproduto"
                  label="Combustível *"
                  outlined
                  dense
                  hide-details="auto"
                  prepend-inner-icon="mdi-fuel"
                  clearable
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Nenhum combustível encontrado</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>

            <!-- Valor (somente para tipo "por_valor") -->
            <v-col cols="12" md="6" v-if="dados.tipo_abastecimento === 1">
              <v-text-field
                  v-model.number="dados.valorunitario"
                  :rules="[rules.required, rules.positivo]"
                  label="Valor (R$) *"
                  type="number"
                  step="0.01"
                  min="0"
                  prefix="R$"
                  outlined
                  dense
                  hide-details="auto"
                  prepend-inner-icon="mdi-currency-usd"
                  placeholder="Ex: 100,00"
              />
            </v-col>

            <!-- Litros (somente para tipo "por_litro") -->
            <v-col cols="12" md="6" v-if="dados.tipo_abastecimento === 2">
              <v-text-field
                  v-model.number="dados.quantidade"
                  :rules="[rules.required, rules.positivo]"
                  label="Litros *"
                  type="number"
                  step="0.01"
                  min="0"
                  suffix="L"
                  outlined
                  dense
                  hide-details="auto"
                  prepend-inner-icon="mdi-gas-station"
                  placeholder="Ex: 50.00"
              />
            </v-col>

            <!-- Observações -->
            <v-col cols="12">
              <v-textarea
                  v-model="dados.observacao"
                  :rules="[rules.maxLength(500)]"
                  label="Observações"
                  rows="3"
                  outlined
                  dense
                  hide-details="auto"
                  prepend-inner-icon="mdi-note-text-outline"
                  counter="500"
                  placeholder="Informações adicionais sobre a requisição..."
              />
            </v-col>

            <!-- Resumo da Requisição -->
            <v-col cols="12" v-if="mostrarResumo">
              <v-card outlined class="resumo-card">
                <v-card-subtitle class="pb-2 d-flex align-center">
                  <v-icon left color="info">mdi-information</v-icon>
                  <span class="font-weight-medium">Resumo da {{ modoEdicao ? 'Requisição' : 'Nova Requisição' }}</span>
                </v-card-subtitle>
                <v-card-text class="pt-0">
                  <v-row dense>
                    <v-col cols="12" sm="6" md="3">
                      <div class="text-caption grey--text text--darken-1">Veículo</div>
                      <div class="font-weight-medium">{{ veiculoSelecionado.nomeveiculo || '-' }}</div>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <div class="text-caption grey--text text--darken-1">Placa</div>
                      <div class="font-weight-medium">{{ veiculoSelecionado.placa || '-' }}</div>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <div class="text-caption grey--text text--darken-1">Tipo</div>
                      <div class="font-weight-medium">{{ getTipoRequisicaoText(dados.tipo_abastecimento) }}</div>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <div class="text-caption grey--text text--darken-1">Combustível</div>
                      <div class="font-weight-medium">{{ combustivelSelecionado }}</div>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <div class="text-caption grey--text text--darken-1">Colaborador</div>
                      <div class="font-weight-medium">{{ colaboradorSelecionado }}</div>
                    </v-col>
                    <v-col cols="12" sm="6" md="3" v-if="dados.valorunitario">
                      <div class="text-caption grey--text text--darken-1">Valor</div>
                      <div class="font-weight-medium">{{ dados.valorunitario | formataDinheiro }}</div>
                    </v-col>
                    <v-col cols="12" sm="6" md="3" v-if="dados.quantidade">
                      <div class="text-caption grey--text text--darken-1">Litros</div>
                      <div class="font-weight-medium">{{ dados.quantidade }}L</div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>

            <!-- Botões de Ação -->
            <v-col cols="12" class="d-flex justify-end align-center pt-6" style="gap: 12px;">
              <v-btn
                  color="grey"
                  outlined
                  elevation="0"
                  @click="limparFormulario"
                  :disabled="salvando"
              >
                <v-icon>mdi-eraser</v-icon>
                <span class="ml-2 d-none d-sm-flex">Limpar</span>
              </v-btn>

              <v-btn
                  color="green darken-2"
                  class="white--text"
                  elevation="2"
                  type="submit"
                  :loading="salvando"
                  :disabled="salvando"
                  x-large
              >
                <v-icon left>mdi-check</v-icon>
                {{ salvando ? 'Salvando...' : (modoEdicao ? 'Atualizar Requisição' : 'Emitir Requisição') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <!-- Dialog para visualizar imagem completa -->
    <v-dialog v-model="dialogImagem" max-width="800px">
      <v-card>
        <v-card-title class="green darken-2 white--text">
          <v-icon left color="white">mdi-image</v-icon>
          Imagem do Hodômetro
          <v-spacer></v-spacer>
          <v-btn icon color="white" @click="dialogImagem = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-img
              :src="previewImagem"
              contain
              max-height="500"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar para feedback -->
    <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :timeout="snackbar.timeout"
        bottom
    >
      <v-icon left color="white">{{ snackbar.icon }}</v-icon>
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn
            text
            color="white"
            v-bind="attrs"
            @click="snackbar.show = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import mixinFilial from "../../../util/mixinFilial";

export default {
  mixins: [mixinFilial],
  components: {},
  data() {
    return {
      veiculos: [],


      formularioValido: false,
      salvando: false,
      carregandoProdutos: false,
      carregandoVeiculos: false,
      carregandoTiposVeiculos: false,
      carregandoTiposAbastecimento: false,
      carregandoColaboradores: false,
      carregandoFornecedores: false,
      carregandoFiliais: false,
      modoEdicao: false,
      dialogImagem: false,
      search: null,
      search2: null,
      aguardarBuscaColaborador: "",
      aguardarBuscaFornecedor: "",

      dados: {
        idfilial: null,
        idveiculo: null,
        idfuncionario: null,
        idproduto: null,
        tipo_abastecimento: null,
        valorunitario: 0,
        quantidade: 0,
        odometro: null,
        observacao: null,
        path: null,
        idrequisicao: 0,
      },



      veiculoSelecionado: {},
      colaboradores: [],
      fornecedores: [],
      produtos: [],
      tiposVeiculo: [],
      imagemOdometro: null,
      previewImagem: null,
      idfilialColaborador: null,
      idfilialFornecedor: null,

      // Tipos de requisição
      tiposAbastecimento: [],

      // Snackbar
      snackbar: {
        show: false,
        message: '',
        color: 'success',
        icon: 'mdi-check-circle',
        timeout: 4000
      },

      // Regras de validação
      rules: {
        required: value => !!value || 'Campo obrigatório',
        positivo: value => !value || value > 0 || 'Valor deve ser maior que zero',
        inteiro: value => !value || Number.isInteger(Number(value)) || 'Deve ser um número inteiro',
        maxLength: (max) => value => !value || value.length <= max || `Máximo ${max} caracteres`,
        placa: value => {
          if (!value) return true;
          // Formatos: ABC-1234 ou ABC1D23
          const placaAntiga = /^[A-Z]{3}-?[0-9]{4}$/;
          const placaMercosul = /^[A-Z]{3}[0-9][A-Z][0-9]{2}$/;
          const placaLimpa = value.replace(/[^A-Z0-9]/g, '');

          if (!placaAntiga.test(value) && !placaMercosul.test(placaLimpa)) {
            return 'Formato inválido. Use ABC-1234 ou ABC1D23';
          }
          return true;
        },
      }
    };
  },

  computed: {
    ...mapState(["backendUrl", "usuario", "timeLimit"]),

    filiaisFiltro() {
      if (this.filiais.lista) {
        return this.filiais.lista.filter((v) => {
          return (
              v.idfilial !== 4 &&
              v.idfilial !== 12 &&
              v.idfilial !== 13 &&
              v.idfilial !== 25 &&
              v.idfilial !== 29 &&
              v.idfilial !== 33 &&
              v.idfilial !== 37
          );
        });
      } else {
        return [];
      }
    },

    mostrarResumo() {
      return this.dados.idveiculo && this.dados.tipo_abastecimento;
    },

    combustivelSelecionado() {
      const produto = this.produtos.find(p => p.idproduto === this.dados.idproduto);
      return produto ? produto.produto : '-';
    },

    colaboradorSelecionado() {
      const colaborador = this.colaboradores.find(m => m.idcliente === this.dados.idfuncionario);
      return colaborador ? colaborador.nome : '-';
    },

    tipoSelecionado() {
      return this.tiposVeiculo.find(t => t.idtipo === this.dados.idtipo);
    },

    registroObrigatorio() {
      return this.tipoSelecionado && this.tipoSelecionado.flagregistro;
    },
  },

  watch: {
    search: function (val) {
      this.listarColaboradores(val);
    },

    search2: function (val) {
      this.listarFornecedores(val);
    },
  },

  methods: {
    async listarTiposAbastecimento() {
      this.carregandoTiposAbastecimento = true;

      try {
        const res = await axios.post(`${this.backendUrl}tms/requisicao/tipo/abastecimento`, {});
        this.tiposAbastecimento = res.data || [];
      } catch (error) {
        console.error('Erro ao carregar tipos de abastecimento:', error);
        this.mostrarSnackbar('Erro ao carregar tipos de abastecimento', 'error');
      } finally {
        this.carregandoTiposAbastecimento = false;
      }
    },

    async listarTiposVeiculo() {
      this.carregandoTiposVeiculos = true;

      try {
        const res = await axios.post(`${this.backendUrl}tms/tipo/veiculo/listar`,{
          idfilial: this.dados.idfilial || null,
        });
        this.tiposVeiculo = res.data || [];
      } catch (error) {
        console.error('Erro ao carregar tipos de veículo:', error);
        this.mostrarSnackbar('Erro ao carregar tipos de veículo', 'error');
      } finally {
        this.carregandoTiposVeiculos = false;
      }
    },

    alteraTipoVeiculo(){
      this.dados.odometro = null;
      this.dados.path = null;
      this.imagemOdometro = null;
      this.previewImagem = null;
      this.listarVeiculos();
    },

    async listarVeiculos() {
      this.carregandoVeiculos = true;

      try {
        this.veiculoSelecionado.placa = null;
        this.dados.idveiculo = null;

        const res = await axios.post(`${this.backendUrl}tms/veiculo/listar`, {
          idfilial: this.dados.idfilial || null,
          idtipo: this.dados.idtipo || null,
        });
        this.veiculos = res.data || [];
      } catch (error) {
        console.error('Erro ao carregar veículos:', error);
        this.mostrarSnackbar('Erro ao carregar veículos', 'error');
      } finally {
        this.carregandoVeiculos = false;
      }
    },

    async listarColaboradores(val) {
      // Limpa timeout anterior para evitar múltiplas requisições
      clearTimeout(this.aguardarBuscaColaborador);

      this.aguardarBuscaColaborador = setTimeout(async () => {
        this.carregandoColaboradores = true;

        try {
          const res = await axios.post(`${this.backendUrl}cliente/listar`, {
            tipo: 'U,M,V',
            limit: 30,
            offset: 0,
            busca: val || null,
            idfilial: this.idfilialColaborador || null,
          });

          this.colaboradores = res.data?.lista || [];

        } catch (error) {
          console.error('Erro ao carregar colaboradores:', error);
          this.colaboradores = [];
          this.mostrarSnackbar('Erro ao carregar colaboradores', 'error');

        } finally {
          this.carregandoColaboradores = false;
        }
      }, this.timeLimit);
    },

    listarTodosColaboradores(search) {
      this.idfilialColaborador = null;
      this.listarColaboradores(search);
    },

    async listarFornecedores(val) {
      // Limpa timeout anterior para evitar múltiplas requisições
      clearTimeout(this.aguardarBuscaFornecedor);

      this.aguardarBuscaFornecedor = setTimeout(async () => {
        this.carregandoFornecedores = true;

        try {
          const res = await axios.post(`${this.backendUrl}cliente/listar`, {
            tipo: 'A,F',
            limit: 30,
            offset: 0,
            busca: val || null,
          });

          this.fornecedores = res.data?.lista || [];

        } catch (error) {
          console.error('Erro ao carregar fornecedores:', error);
          this.fornecedores = [];
          this.mostrarSnackbar('Erro ao carregar fornecedores', 'error');

        } finally {
          this.carregandoFornecedores = false;
        }
      }, this.timeLimit);
    },

    async atualizaDadosFilial() {
      this.dados.idveiculo = null;
      this.dados.idfuncionario = null;
      this.dados.idclifor = null;

      this.idfilialColaborador = this.dados.idfilial;
      this.idfilialFornecedor = this.dados.idfilial;

      this.listarVeiculos();
      this.listarColaboradores();
      this.listarFornecedores();
      this.listarTiposVeiculo();
    },

    podeAlterarFilial() {
      return this.permissao("filial_listar");
    },

    selecionarVeiculo() {
      if (this.dados.idveiculo) {
        const veiculo = this.veiculos.find(v => v.idveiculo === this.dados.idveiculo);
        if (veiculo) {
          this.veiculoSelecionado = { ...veiculo };
          // Pré-selecionar combustível baseado no veículo se disponível
          if (veiculo.idproduto) {
            this.dados.idproduto = veiculo.idproduto;
          }
        }
      } else {
        this.veiculoSelecionado = {};
      }
    },

    limparValoresAbastecimento() {
      this.dados.valorunitario = 0;
      this.dados.quantidade = 0;
    },

    processarImagem(file) {
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.previewImagem = e.target.result;
          this.dados.path = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        this.previewImagem = null;
        this.dados.path = null;
      }
    },

    visualizarImagemCompleta() {
      this.dialogImagem = true;
    },

    async salvarRequisicao() {
      if (!this.$refs.form.validate()) {
        this.mostrarSnackbar('Por favor, corrija os erros no formulário', 'error');
        return;
      }

      this.salvando = true;

      try {
        const payload = {
          ...this.dados,
          acao: this.modoEdicao ? "U" : "I",
        };

        const response = await axios.post(`${this.backendUrl}tms/requisicao/inserir`, payload);

        localStorage.setItem("filtros_requisicao", JSON.stringify({
            idfilial: payload.idfilial || null,
            idveiculo: null,
            idstatus: null
        }));

        const mensagem = this.modoEdicao
            ? 'Requisição atualizada com sucesso!'
            : 'Requisição emitida com sucesso!';

        this.mostrarSnackbar(mensagem, 'success');

        this.$router.push({ name: 'financeiro-abastecimentos-requisicoes',params: { requisicao: response.data } })

        if (!this.modoEdicao) {
          this.$refs.form.reset();
        }

      } catch (error) {
        console.error('Erro ao salvar requisição:', error);
        const mensagem = error.response?.data?.erro || 'Erro ao salvar requisição. Tente novamente.';
        this.mostrarSnackbar(mensagem, 'error');
      } finally {
        this.salvando = false;
      }
    },

    limparFormulario() {
      this.$refs.form.reset();
      this.dados = {
        idfilial: null,
        idveiculo: null,
        idfuncionario: null,
        idproduto: null,
        tipo_abastecimento: null,
        valorunitario: 0,
        quantidade: 0,
        odometro: null,
        observacao: null,
        path: null,
        idrequisicao: 0,
      };
      this.veiculoSelecionado = {};
      this.imagemOdometro = null;
      this.previewImagem = null;
    },

    async listarProdutos() {
      this.carregandoProdutos = true;
      try {
        const res = await axios.post(`${this.backendUrl}tms/produto/listar`, {
          busca: null,
        });

        this.produtos = res.data || [];
      } catch (error) {
        console.error('Erro ao carregar produtos:', error);
        this.mostrarSnackbar('Erro ao carregar combustíveis', 'error');
      } finally {
        this.carregandoProdutos = false;
      }
    },


    async carregarRequisicao(id) {
      try {
        const res = await axios.post(`${this.backendUrl}tms/requisicao/listar`, {
          idrequisicao: id
        });

        if (res.data && res.data.length > 0) {
          this.dados = { ...this.dados, ...res.data[0] };
          this.modoEdicao = true;

          // Carregar dados do veículo
          if (this.dados.idveiculo) {
            this.selecionarVeiculo();
          }

          // Carregar preview da imagem se existir
          if (this.dados.path) {
            this.previewImagem = this.dados.path;
          }
        }
      } catch (error) {
        console.error('Erro ao carregar requisição:', error);
        this.mostrarSnackbar('Erro ao carregar dados da requisição', 'error');
      }
    },

    async carregarColaboradorPorId(idclifor) {
      try {
        const res = await axios.post(`${this.backendUrl}cliente/listar`, {
          tipo: "U,M,V",
          busca: (idclifor).toString()
        });

        if (res.data && res.data.lista && res.data.lista.length > 0) {
          this.colaboradores = res.data.lista;
        }
      } catch (error) {
        console.error('Erro ao carregar colaborador:', error);
      }
    },

    getTipoRequisicaoText(tipo) {
      const tipos = {
        1: 'Por Valor',
        2: 'Por Litro',
        3: 'Completar'
      };
      return tipos[tipo] || '-';
    },

    mostrarSnackbar(message, type = 'info') {
      const configs = {
        success: { color: 'success', icon: 'mdi-check-circle' },
        error: { color: 'error', icon: 'mdi-alert-circle' },
        warning: { color: 'warning', icon: 'mdi-alert' },
        info: { color: 'info', icon: 'mdi-information' }
      };

      this.snackbar = {
        show: true,
        message,
        timeout: 4000,
        ...configs[type]
      };
    }
  },

  async mounted() {
    // Verificar se estamos em modo de edição
    const id = this.$route.params.id;
    if (id) {
      this.modoEdicao = true;
    }

    this.dados.idfilial = this.usuario.idfilial;
    this.idfilialColaborador = this.usuario.idfilial;
    this.idfilialFornecedor = this.usuario.idfilial;

    // Carregar dados iniciais
    await Promise.all([
      this.listarTiposAbastecimento(),
      this.listarTiposVeiculo(),
      this.listarVeiculos(),
      this.listarColaboradores(),
      this.listarFornecedores(),
      this.listarProdutos()
    ]);

    // Carregar dados da requisição se estiver editando
    if (this.modoEdicao && id) {
      await this.carregarRequisicao(id);
    }
  }
};
</script>

<style scoped>
.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e0e0e0;
}

.resumo-card {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.preview-image {
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.2s;
}

.preview-image:hover {
  transform: scale(1.05);
}

.v-text-field--outlined >>> .v-input__prepend-inner {
  margin-top: 14px;
}

.v-textarea--outlined >>> .v-input__prepend-inner {
  margin-top: 14px;
}

.v-autocomplete--outlined >>> .v-input__prepend-inner {
  margin-top: 14px;
}

.v-select--outlined >>> .v-input__prepend-inner {
  margin-top: 14px;
}

.v-file-input--outlined >>> .v-input__prepend-inner {
  margin-top: 14px;
}
</style>